import { VNode } from 'preact';

export enum ToastType {
  Success = 'success',
  Error = 'error',
}

export interface ToastNotification {
  id: string;
  type: ToastType;
  text: string | VNode;
  duration?: number;
}
